import { useEffect, useState } from "react";
import { Mail, Phone } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  useEffect(() => { api.get("/admin/customers").then((r) => setCustomers(r.data)); }, []);

  return (
    <div data-testid="admin-customers">
      <div className="flex items-center justify-between mb-8">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 font-semibold">CRM</div>
          <h1 className="font-display text-3xl font-bold text-white mt-1">Kunden</h1>
        </div>
        <div className="text-sm text-zinc-500">{customers.length} Kunden</div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {customers.map((c) => (
          <div key={c.id} className="bg-[#141417] rounded-2xl border border-white/5 p-5" data-testid={`customer-${c.id}`}>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-[#DC1928] text-white flex items-center justify-center font-display font-semibold">
                {c.name?.[0]?.toUpperCase() || "?"}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display font-semibold text-white">{c.name}</div>
                <div className="text-xs text-zinc-500">Kunde seit {(c.created_at || "").slice(0, 10)}</div>
              </div>
            </div>
            <div className="mt-4 space-y-1.5 text-sm">
              {c.phone && (
                <a href={`tel:${c.phone}`} className="flex items-center gap-2 text-zinc-400 hover:text-[#FF2D40]">
                  <Phone className="w-3.5 h-3.5" /> {c.phone}
                </a>
              )}
              {c.email && (
                <a href={`mailto:${c.email}`} className="flex items-center gap-2 text-zinc-400 hover:text-[#FF2D40] truncate">
                  <Mail className="w-3.5 h-3.5 shrink-0" /> {c.email}
                </a>
              )}
            </div>
            <div className="mt-4 pt-3 border-t border-white/5 flex gap-4 text-xs text-zinc-500">
              <div><span className="font-medium text-white numeric">{c.repair_count}</span> Reparaturen</div>
              <div><span className="font-medium text-white numeric">{c.order_count}</span> Bestellungen</div>
            </div>
          </div>
        ))}
        {customers.length === 0 && <div className="col-span-full text-center py-16 text-zinc-500">Noch keine Kunden registriert. Kundendaten werden bei Reparatur-Anfragen automatisch erstellt.</div>}
      </div>
    </div>
  );
}
